import constants from '@/core/constants';
import DateHelpers from '@/core/helpers/DateHelper';
import TextHelper from '@/core/helpers/TextHelper';

const getColorCard = (someType: any) => {
  let backgroundColor;
  switch (someType) {
    case constants.CARD_TYPES.CURSO_REMOTO: // curso : remoto o presencial
      backgroundColor = '#B3EBFE';
      break;
    case constants.CARD_TYPES.CURSO_VIRTUAL: // curso : virtual
      backgroundColor = '#FCDAE2';
      break;
    case constants.CARD_TYPES.CURSO_PRESENCIAL: // curso : presencial
      backgroundColor = '#FFF8F7';
      break;
    default:
      backgroundColor = '#2a3247';
      break;
  }
  return backgroundColor;
};

const getCardTagLabel = (someType: any) => {
  switch (someType) {
    case constants.CARD_TYPES.CURSO_REMOTO:
      return 'Virtual en vivo';
    case constants.CARD_TYPES.ACTIVIDAD:
      return 'Eventos';
    case constants.CARD_TYPES.REFORZAMIENTO:
      return 'R. Académico';
    case constants.CARD_TYPES.CURSO_VIRTUAL:
      return 'Virtual 24/7';
    case constants.CARD_TYPES.CURSO_PRESENCIAL:
      return 'Presencial';
    case constants.CARD_TYPES.EXAMEN:
      return 'Evaluación';
    default:
      return 'Remoto';
  }
};

const getCardTagBackgroundColor = (someType: any) => {
  let backgroundColor;
  switch (someType) {
    case constants.CARD_TYPES.CURSO_PRESENCIAL:
      backgroundColor = '#BF500B';
      break;
    case constants.CARD_TYPES.CURSO_VIRTUAL:
      backgroundColor = '#B21F5F';
      break;
    case constants.CARD_TYPES.CURSO_REMOTO:
      backgroundColor = '#0F6778';
      break;
    default:
      backgroundColor = '#B21F5F';
  }
  return backgroundColor;
};

export const CourseSummary = (someType: any, element: any, dateEvent: any) => {
  let returnCard: any;
  let professor;

  if (typeof element.professor === 'string') {
    professor = element.professor;
  } else if (Array.isArray(element.professor) && element.professor.length > 0) {
    const { lastName, firstName } = element.professor[0];
    professor = `${lastName}, ${firstName}`;
  }

  const LowerName = element?.name?.toLowerCase();
  const courseName = LowerName?.charAt(0).toUpperCase() + LowerName?.slice(1);
  const start = DateHelpers.formatHour(element?.start);
  const end = DateHelpers.formatHour(element?.end);

  const dateFormated = TextHelper.capitalize(
    DateHelpers.formatFullDate2(dateEvent?.date)
  );
  switch (someType) {
    case constants.CARD_TYPES.CURSO_VIRTUAL:
      returnCard = {
        summary: {
          title: TextHelper.capitalize(element.name)
        },
        detail: {
          title: courseName,
          date: element.date,
          hour: `Disponible las 24 horas durante el ciclo. Recomendamos 4 horas por semana.`,
          teacher: professor,
          link: element.linkZoom
        },
        tag: {
          color: getColorCard(someType),
          label2: getCardTagLabel(someType),
          background: getCardTagBackgroundColor(someType)
        },
        classTypeText: element.descAmb
          ? element.descAmb.charAt(0).toUpperCase() +
            element.descAmb.toLowerCase().slice(1)
          : ''
      };
      break;
    default:
      returnCard = {
        summary: {
          title: TextHelper.capitalize(element.name)
        },
        detail: {
          title: courseName,
          date: dateFormated,
          hour: `${dateFormated} de ${start} a ${end}`,
          teacher: professor,
          link: element.linkZoom
        },
        tag: {
          color: getColorCard(someType),
          label2: getCardTagLabel(someType),
          background: getCardTagBackgroundColor(someType)
        },
        classTypeText: element.descAmb
          ? element.descAmb.charAt(0).toUpperCase() +
            element.descAmb.toLowerCase().slice(1)
          : ''
      };
  }
  return returnCard;
};
